import Chip, { CHIP_COLORS } from "../../../../../components/chip/chip";
import { SHIPMENT_STATUS_ENUM } from "../../../../manage-returns/rma-page/rma-types";
import { SHIPMENT_STATUS_TRANSLATION_KEYS_MAP } from "../../../shipment.types";

interface IProps {
    statusCode: SHIPMENT_STATUS_ENUM;
    status: typeof SHIPMENT_STATUS_TRANSLATION_KEYS_MAP[keyof typeof SHIPMENT_STATUS_TRANSLATION_KEYS_MAP];
}

const StatusChipColorMap: { [key: string]: CHIP_COLORS } = {
    [SHIPMENT_STATUS_ENUM.LABEL_CREATED]: CHIP_COLORS.ORANGE,
    [SHIPMENT_STATUS_ENUM.RECEIVED]: CHIP_COLORS.GREEN,
    [SHIPMENT_STATUS_ENUM.REJECTED]: CHIP_COLORS.RED,
    [SHIPMENT_STATUS_ENUM.VERIFIED]: CHIP_COLORS.GREEN,
    [SHIPMENT_STATUS_ENUM.SHIPPED]: CHIP_COLORS.BLUE,
    [SHIPMENT_STATUS_ENUM.OUT_FOR_DELIVERY]: CHIP_COLORS.ORANGE,
    [SHIPMENT_STATUS_ENUM.ERROR]: CHIP_COLORS.RED,
}

const ShipmentsStatusChip: React.FC<IProps> = ({ statusCode, status }) => {
    return (
        <Chip label={status} color={StatusChipColorMap[statusCode] ?? CHIP_COLORS.DEFAULT} />
    )
};

export default ShipmentsStatusChip;
